import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { EvacuationFormComponent } from '../../hero-report/evacuation-form/evacuation-form.component';

@Component({
  selector: 'app-hero-report-step3',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, EvacuationFormComponent],
  templateUrl: './hero-report-step3.component.html',
  styleUrls: ['./hero-report-step3.component.scss'],
})
export class HeroReportStep3Component {
  @Input() formGroup!: FormGroup;
  @Input() possibleIdentification: string;
}
